const SPECIAL_COLUMNS = {
  kebab: 'special-kebab-column',
  checkbox: 'special-checkbox-column',
  icon: 'special-icon-column',
};
const CONSTANTS = {
  SPECIAL_COLUMNS,
  SPECIAL_COLUMNS_LIST: Object.values(SPECIAL_COLUMNS),
  DATA_GRID_ROW_HEIGHT: 3, // in rems
  DATA_GRID_ROW_HEIGHT_MAX: 6, // in rems
  ROWS_AMOUNT: 20,
  DATA_GRID_BLOCK: 'data-grid',
};
export default CONSTANTS;
